import styled from 'styled-components';
import { Text } from '~/components/ui/Text';
import shadow from '../../assets/images/trucks_job/unavailable_shadow.png';

const StyledContainerText = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	border-top: 1px solid rgba(255, 255, 255, 0.1);

	& > ${Text} {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		font-weight: 500;
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledContainerVehicle = styled.div`
	width: 100%;
	height: 100%;
	border-top: 1px solid rgba(255, 255, 255, 0.1);

	& > ${Text} {
		font-size: 14px;
		text-align: center;
		color: #ffffff;
		opacity: 0.25;
		margin-top: 40px;
	}
`;

const StyledVehicleGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 20px;
	padding: 0 20px 20px;
`;

const StyledVehicleItem = styled.div`
	position: relative;
	height: 180px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 10px;
	overflow: hidden;

	img {
		position: absolute;
		bottom: 20px;
		left: 50%;
		transform: translateX(-50%);
		height: 96px;
	}
`;

const StyledShadow = styled.div`
	position: absolute;
	top: -150px;
	left: 50%;
	transform: translateX(-50%);
	width: 300px;
	height: 300px;
	background-image: url(${shadow});
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
`;

const StyledVehicleName = styled(Text)`
	position: absolute;
	top: 20px;
	left: 50%;
	transform: translateX(-50%);
	font-weight: 500;
	font-size: 14px;
	text-align: center;
	color: #ffffff;
`;

export {
	StyledContainerText,
	StyledContainerVehicle,
	StyledShadow,
	StyledVehicleGrid,
	StyledVehicleItem,
	StyledVehicleName,
};
